export const paginateData = (data, itemsPerPage) => {
	let paginatedResults = [];
	let startIndex = 0;
	let endIndex = startIndex + itemsPerPage;
	let pageCount = 0;
	//restructure data into 2 dimensional array based on the itemsPerPage argument
	while (endIndex <= data.length) {
		paginatedResults.push(data.slice(startIndex, endIndex));
		startIndex = startIndex + itemsPerPage;
		endIndex = startIndex + itemsPerPage;
		pageCount++;
	}
	// add leftovers
	endIndex = pageCount * itemsPerPage;
	paginatedResults.push(data.slice(endIndex, data.length));
	return paginatedResults;
};
